// imports
import Isotope from "isotope";
import VanillaModal from "vanilla-modal";
var imagesLoaded = require("imagesloaded");

// helpers
var classHelper = require("./helpers/class-helper.js");
var eventHelper = require("./helpers/event-helper.js");
var ajaxHelper = require("./helpers/ajax-helper.js");

// Modules
let menu = require("./modules/menu");

window.onload = function() {

  const modal = new VanillaModal();


  //
  var pricelistlink = document.querySelector("a[href$='#pricelist']");
  if (pricelistlink) {
    eventHelper.addEvent(pricelistlink, "click", function(e) {
      e.preventDefault();
      modal.open("#pricelist");
    });
  }

  //
  var notice = document.querySelector("#notice-wrapper");
  if (notice) {
    const noticeModal = new VanillaModal();
    noticeModal.open('#notice-wrapper');
  }


  var twoColumn = document.querySelector("ul.pop-column-2");
  var gridSizer = document.querySelector(".grid-sizer");
  var gutterSizer = document.querySelector(".gutter-sizer");
  if (twoColumn) {
    // news items
    imagesLoaded(twoColumn, function(instance) {
      // images have loaded
      let iso = new Isotope(twoColumn, {
        itemSelector: ".item",
        percentPosition: true,
        masonry: {
          columnWidth: gridSizer,
          gutter: gutterSizer
        }
      });
      // console.log(instance, 'images have loaded');
    });
  }

  // menu
  menu.init();

  //
}; // end window



// WEBPACK FOOTER //
// ./main.js